export enum ThirdPartyType {
  Individual = 'Individual',
  Business = 'Business',
  Unknown = 'Unknown',
}
